import { render, staticRenderFns } from "./criminal-law-part-3.vue?vue&type=template&id=7df7d38d&"
import script from "./criminal-law-part-3.vue?vue&type=script&lang=js&"
export * from "./criminal-law-part-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports